import { useSyncExternalStore } from "react";

import {
    getAuthSnapshot,
    getServerAuthSnapshot,
    loginWithPassword,
    logoutSession,
    retryAuthSession,
    subscribeAuthSession,
    type AuthSnapshot,
} from "@/api";

export interface UseAuthResult extends AuthSnapshot {
    login: typeof loginWithPassword;
    logout: typeof logoutSession;
    /** Повторить первый `isauthorized` после ошибки сети. */
    retry: typeof retryAuthSession;
}

/**
 * Сессия вкладки (`authSession`): `status` (`unknown` до ответа первого `isauthorized`), `user`
 * (`email`, `isSuperuser`), ошибка старта и причина завершения. Запускает сессию `AuthProvider`.
 */
export function useAuth(): UseAuthResult {
    const snapshot = useSyncExternalStore(subscribeAuthSession, getAuthSnapshot, getServerAuthSnapshot);
    return { ...snapshot, login: loginWithPassword, logout: logoutSession, retry: retryAuthSession };
}
